const PublicConfig = require('./publicConfig');

const LOADABLE_SETTINGS = [
  'database',
  'sentry',
  'tokens',
  'aws',
  'email',
  'topaziobank',
  'bigdatacorp',
  'billing',
  'contacerta.companies.tokens',
  'celcoin',
  'granatum',
  'abcbrasil',
  'btg',
  'mtls.cert',
  'redis',
  'hubspot',
  'flipt-credentials',
  'pix.qrcode.cert'
];
const VALID_ENV = ['production', 'sandbox', 'homolog', 'development'];

class Settings {
  #cache = {};
  #env;
  #namespace;
  constructor() {
    this.#cache = {};
    this.#env = this.#getENV();
    this.#namespace = this.#env + '.';
  }

  #getENV() {
    const ENV = (process.env.NODE_ENV || '').toLowerCase();

    if (!ENV || !VALID_ENV.includes(ENV)) {
      return 'development';
    }

    return ENV;
  }

  async #loadPublicConfig() {
    if (this.#cache.url) {
      return;
    }
    const publicConfig = new PublicConfig();
    this.#cache.url = await publicConfig.loadURLs(this.#env);
  }

  #getSecret(secretName) {
    const { SecretsManager } = require('@transfeeradev/aws-sdk');

    secretName = this.#namespace + secretName;

    return new Promise((resolve, reject) => {
      SecretsManager.getSecretValue(
        {
          SecretId: secretName
        },
        (e, data) => {
          if (e) {
            if (e.code === 'ResourceNotFoundException') {
              return reject(new Error(`Secret config named '${secretName}' not found`));
            }
            return reject(e);
          }

          return resolve(JSON.parse(data.SecretString));
        }
      );
    });
  }

  async #get(secret) {
    if (this.#cache[secret]) {
      return this.#cache[secret];
    }

    await this.load(secret);

    return this.#cache[secret];
  }

  async get(...secrets) {
    secrets = secrets.map(s => s.toLowerCase());

    if (secrets.includes('url')) {
      await this.#loadPublicConfig();
    }

    if (secrets.length === 1) {
      return this.#get(secrets[0]);
    }

    const results = await Promise.all(secrets.map(s => this.#get(s)));

    return secrets.reduce((result, curr, i) => {
      result[curr] = results[i];
      return result;
    }, {});
  }

  getCached(...secrets) {
    secrets = secrets.map(s => s.toLowerCase());

    if (secrets.length === 1) {
      return this.#cache[secrets[0]];
    }

    const results = secrets.map(s => this.#cache[s]);

    return secrets.reduce((result, curr, i) => {
      result[curr] = results[i];
      return result;
    }, {});
  }

  async load(...secrets) {
    await this.#loadPublicConfig();

    return Promise.all(
      secrets.map(async secret => {
        secret = secret.toLowerCase();

        this.#cache[secret] = await this.#getSecret(secret);
      })
    );
  }

  loadAll() {
    return this.load(...LOADABLE_SETTINGS);
  }
}

module.exports = new Settings();
// constants
module.exports.URL = 'url';
module.exports.DATABASE = LOADABLE_SETTINGS[0];
module.exports.SENTRY = LOADABLE_SETTINGS[1];
module.exports.TOKENS = LOADABLE_SETTINGS[2];
module.exports.AWS = LOADABLE_SETTINGS[3];
module.exports.EMAIL = LOADABLE_SETTINGS[4];
module.exports.TOPAZIO = LOADABLE_SETTINGS[5];
module.exports.BIGDATACORP = LOADABLE_SETTINGS[6];
module.exports.BILLING = LOADABLE_SETTINGS[7];
module.exports.CONTACERTA_COMPANIES_TOKENS = LOADABLE_SETTINGS[8];
module.exports.CELCOIN = LOADABLE_SETTINGS[9];
module.exports.GRANATUM = LOADABLE_SETTINGS[10];
module.exports.ABC_BRASIL = LOADABLE_SETTINGS[11];
module.exports.BTG = LOADABLE_SETTINGS[12];
module.exports.MTLS_CERT = LOADABLE_SETTINGS[13];
module.exports.REDIS = LOADABLE_SETTINGS[14];
module.exports.HUBSPOT = LOADABLE_SETTINGS[15];
module.exports.FLIPT = LOADABLE_SETTINGS[16];
module.exports.PIX_QRCODE_CERT = LOADABLE_SETTINGS[17];
